import React, { useCallback, useRef } from 'react';

import { SocketProvider as GGSocketProvider } from '@gogame/sockets';

import { EVENT_REFRESH_PAGE } from './constants';

const protocol =
  process.env.REACT_APP_API_PROTOCOL === 'https:' ? 'wss:' : 'ws:';

const host = `${protocol}//${process.env.REACT_APP_SOCKETS_HOST}`;
const path = `${process.env.REACT_APP_SOCKETS_PATH}`;

export const SocketProvider = ({ children }) => {
  const unsubscribeRef = useRef(null);

  const handleOnConnected = useCallback((socket) => {
    socket.on(EVENT_REFRESH_PAGE, async () => {
      window.location.reload();
    });
  }, []);

  const handleOnDisconnected = useCallback(() => {
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
    }
  }, []);

  const autoConnect = process.env.REACT_APP_SKIP_SOCKETS !== 'true';

  return (
    <GGSocketProvider
      host={host}
      path={path}
      onConnected={handleOnConnected}
      onDisconnected={handleOnDisconnected}
      autoConnect={autoConnect}
    >
      {children}
    </GGSocketProvider>
  );
};
